import { render, staticRenderFns } from "./BodyPartCards.vue?vue&type=template&id=0e7a7546&"
import script from "./BodyPartCards.vue?vue&type=script&lang=js&"
export * from "./BodyPartCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports